<template>
    <div style="background-color:#fff" >
      <mini_head_top> </mini_head_top>
      <van-row    type="flex"  justify="space-between" style="margin: auto; margin-top: 10px; padding: auto; width: 100%;text-align: left">
        <van-row>
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">个人信息</span>
        </van-row>
        <el-link style="margin-right: 10px;" type="primary" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-row>
      <div style="overflow: auto; background-color: ghostwhite;  height: calc(80vh - 40px) ">
        <div>
          <div style ="margin-top: 5px;display: flex; margin-left: 20px; ">
            <div>
              <el-image  v-if = "userInfo.imageUrl != null && userInfo.imageUrl != '' "
                style="width: 100px; height: 100px ; border-radius: 1px;"
                :src="userInfo.imageUrl"
                :fit="'fit'">
              </el-image>
              <el-avatar v-else style="display: flex; background-color: rgb(47, 47, 228); height:100px;width:100px; align-items: center; justify-content: space-around; "> {{ userInfo.fullName  }} </el-avatar>
            </div>
            <div style="margin-left: 10px;text-align: left;">
              <div>  
                  姓名: {{userInfo.fullName }}
              </div>
              <div>  
                  工号: {{userInfo.usrName }}
              </div>
              <div>  
                  性别: {{userInfo.genderShow }}
              </div>
              <div>  
                  电话: {{userInfo.mobilePhone }}
              </div>
              <div>  
                  邮箱: {{userInfo.email }}
              </div>
              <div>  
                  团队: {{userInfo.deptName }}
              </div>
              <div style="margin-top: 20px">  
                  <el-button type="primary" @click = "handleEdit"> 修改个人信息</el-button>
                  <el-button type="warning" @click="changePass"> 修改密码</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog width="98%" :visible.sync="dialogVisual.editUserInfoDialogVisible" v-on:close ="clearEditUserInfoForm" >
        <div slot="title" class="dialog-footer">
          <span> 用户{{ userInfoForm.usrName }} 信息变更 </span>
        </div>
        <el-form  label-width="20%"  :model="userInfoForm">
          <el-form-item label="更新头像:"  style="text-align:left" label-width="20%"  >
            <el-switch
              v-model="userInfoForm.updateImage"
              active-text="是"
              inactive-text="否"  @change ="funcUpdateImageChange">
            </el-switch>
          </el-form-item>
          <el-form-item  style="text-align:left" label-width="20%"  label="头像:"  >
            <el-upload
            :action="'#'"
            list-type="picture-card"
            :auto-upload="false"
            :ref="userInfoForm.refElUpload"   
            :file-list="userInfoForm.fileList" 
            :limit="userInfoForm.limit">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file,userInfoForm.refElUpload)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          </el-form-item>
          <el-form-item  label="姓名:">
            <el-input v-model="userInfoForm.fullName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item  label="性别:">
            <el-select  style="width: 100%" v-model="userInfoForm.gender" placeholder="请选择">
              <el-option
                v-for="item in genderArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机:">
            <el-input  v-model="userInfoForm.mobilePhone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:">
            <el-input v-model="userInfoForm.email" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="团队:"  >
            <el-select  v-model="userInfoForm.deptId" style="width:100%" placeholder="请选择" >
              <el-option
                v-for="item in deptOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureChange">确定变更</el-button>
        </div>
      </el-dialog>

      <el-dialog  width="98%" :visible.sync="dialogVisual.changePassVisible" v-on:close ="clearEditUserPassForm" >
        <div slot="title" class="dialog-footer">
          <span> 修改{{ userInfoForm.usrName }} 密码 </span>
        </div>
        <el-form  label-width="20%"  :model="userInfoForm">
          <el-form-item label="原密码:">
            <el-input  v-model="changePassword.oldPassword" show-password  autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码:">
            <el-input v-model="changePassword.newPassword" show-password  autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureChangePass">确定变更</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
    import axios from  '@/api/axiosConfig'
    import mini_head_top from "@/mini_pages/mini_head_top"
    import {getToken} from  '@/api/utils'
    import {stringIsNullOrEmpty,regCheck} from  '@/api/utils'
    import {MESSAGE_DURATION,GENDER_ARR,passWordReg, regEmail,regMobilePone} from  '@/api/constant'
    import { Dialog } from 'vant';
    export default {
      name : 'mini_self',
      data () {
        return {
          tokenObj:{token:''},
          genderArr: GENDER_ARR,
          userInfo :{
            id :'',
            init : false,
            fullName: '',
            usrName: '',
            deptName : '',
            deptId :'',
            gender :'',
            genderShow :'',
            email :'',
            mobilePhone :'',
            imageUrl: ''
          },
          deptOptions: [],
          userInfoForm: {
            updateImage:false,
            fullName: '',
            usrName: '',
            deptId : '',
            gender :'',
            email :'',
            mobilePhone :'',
            fileList:[],
            id : '',
            refElUpload :"userImagUpload",
            limit : 1,
            imageUrl :''
          },
          dialogVisual:{
            editUserInfoDialogVisible:false,
            changePassVisible :false
          },
          changePassword :{
            oldPassword:'',
            newPassword :''
          }
        }
      },
      methods: {
        changePass(){
           this.dialogVisual.changePassVisible =true
        },
        ensureChangePass(){
          try{ 
            stringIsNullOrEmpty(this.changePassword.oldPassword,'请输入旧密码!');
            stringIsNullOrEmpty(this.changePassword.newPassword,'请输入新密码!');
            regCheck(passWordReg, this.changePassword.newPassword,'新密码格式不正确，格式为6到16位大小写字母,数字,@,$的组合!');
          }catch (e){
            this.$message({
              showClose: true,
              message: e,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
            return
          }
          let dat = {
            oldPass:this.changePassword.oldPassword,
            newPass:this.changePassword.newPassword
          }
          let s = JSON.stringify(dat);
          let url = "/bc/exa/usr/changePass"
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              this.$message({
                showClose: true,
                message: '密码修改成功!',
                type: 'success',
                duration: MESSAGE_DURATION
              })
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })

        },
        restPass(){

          Dialog.confirm({
            title: '标题',
            message: "您确定要重置密码么?",
          })
          .then(() => {
            this.doRestPass()
          })
          .catch(() => {
            // on cancel
          })
          // this.$confirm('您确定要重置密码么?', '提示', {
          //     confirmButtonText: '确定',
          //     cancelButtonText: '取消',
          //     type: 'warning'
          //   }).then(() => {
          //     this.doRestPass();
          //   }).catch(() => {
          //     this.$message({
          //       type: 'info',
          //       message: '已经取消重置用户密码!'
          //     });
          //   })
        },
        doRestPass(){
          let url = "/bc/exa/usr/resetPass"
          let data = {id: this.userInfo.id}
          let s = JSON.stringify(data)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              this.$message({
                showClose: true,
                message: '重置密码成功!',
                type: 'success',
                duration: MESSAGE_DURATION
              })
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        },
        funcUpdateImageChange(){
          let rawImageUrl = this.userInfoForm.imageUrl
          let rawHasFile = false
          if(rawImageUrl != null && rawImageUrl != ''){
            rawHasFile = true
          }
          if(this.userInfoForm.updateImage){
            if(this.$refs[this.userInfoForm.refElUpload] != null){
              this.$refs[this.userInfoForm.refElUpload].clearFiles()
            }
            if(rawHasFile){
              this.userInfoForm.fileList.splice(0)
            }
          }else{
            if(rawHasFile){
              this.userInfoForm.fileList.push({name:this.userInfoForm.usrName, url:rawImageUrl})
            }
          }
        },
        handleRemove(file,refElUpload) {
          let fileList = this.$refs[refElUpload].uploadFiles
          let index = fileList.indexOf(file)
          this.$refs[refElUpload].uploadFiles.splice(index,1)
        },
        ensureChange(){
          // Dialog.confirm({
          //   title: '标题',
          //   message:'即将更新用户['+this.userInfoForm.usrName+']信息',
          // })
          // .then(() => {
          //   this.doChangeUserInfo()
          // })
          // .catch(() => {
          //   // on cancel
          // })
          this.$confirm('即将更新用户['+this.userInfoForm.usrName+']信息', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.doChangeUserInfo()
          }).catch((e) => {
            this.$message({
              type: 'info',
              message: '取消更新！ '+ e
            });
          })
        },
        doChangeUserInfo(){
          try{
            if(this.userInfoForm.updateImage){
              let fileObj = this.$refs[this.userInfoForm.refElUpload]
              if(fileObj == null){
                  throw '更新头像请选择头像1'
              }else{
                let fileList = fileObj.uploadFiles
                if(fileList == null || fileList.length == 0){
                  throw '更新头像请选择头像2'
                }
              }
            }
            if (this.userInfoForm.email != null && this.userInfoForm.email != '') {
              regCheck(regEmail, this.userInfoForm.email,'邮箱格式不正确!');
            }
            if (this.userInfoForm.mobilePhone != null && this.userInfoForm.mobilePhone != '') {
              regCheck(regMobilePone, this.userInfoForm.mobilePhone,'手机号码格式不正确!')
            }
          }catch(e){
            this.$message({
              showClose: true,
              message: e,
              type: 'error',
              duration: MESSAGE_DURATION
            })
            return 
          }
          let url = "/bc/exa/usr/usrEdit"
          let param =  new FormData()
          param.append('id',this.userInfoForm.id)
          param.append('fullName',this.userInfoForm.fullName)
          param.append('usrName', this.userInfoForm.usrName)
          param.append('deptId', this.userInfoForm.deptId)
          param.append('gentle', this.userInfoForm.gender)
          param.append('email', this.userInfoForm.email)
          param.append('mobilePhone', this.userInfoForm.mobilePhone)
          if(this.userInfoForm.updateImage){
            let file = this.$refs[this.userInfoForm.refElUpload].uploadFiles[0]
            param.append('file',file.raw)
          }
        
          axios.post(url, param,{
            headers: {
              'Content-Type': 'multipart/form-data',
              // 'token': this.tokenObj.TOKEN
            }}).then((response) => {
              if (response.data.code === 0){
                this.dialogVisual.editUserInfoDialogVisible= false;
                this.clearEditUserInfoForm();
                this.$message({
                  showClose: true,
                  message: '更新成功',
                  type: 'success',
                  duration: MESSAGE_DURATION
                })
                setTimeout(()=>{this.getUserInfo()},200)
              } else {
                this.$message({
                  showClose: true,
                  message: response.data.message,
                  type: 'error',
                  duration: MESSAGE_DURATION
                })
              }
            }).catch( (err) => {
              this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        },
        clearEditUserInfoForm(){
          this.userInfoForm.fileList.splice(0)
          if(this.$refs[this.userInfoForm.refElUpload] !=null ){
            this.$refs[this.userInfoForm.refElUpload].clearFiles()
          }
          this.userInfoForm.fullName = ''
          this.userInfoForm.usrName =''
          this.userInfoForm.gentle = ''
          this.userInfoForm.updateImage = false
          this.userInfoForm.email = ''
          this.userInfoForm.imageUrl = ''
          this.userInfoForm.mobilePhone = ''
          this.userInfoForm.deptId = ''
          this.userInfoForm.id = ''
        },
        clearEditUserPassForm(){
          this.changePassword.oldPassword = ''
          this.changePassword.newPassword = ''
        },
        async deptListLoad(){
          let url = "/bc/exa/dept/getDeptTree"
          let dat = {}
          let s = JSON.stringify(dat)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              if( response.data.data.length !== 0){
                response.data.data.forEach(t=>{
                  this.deptOptions.push({value: t.id,label: t.deptName })
                })
              }else{
                this.$message({
                  showClose: true,
                  message: '团队列表未查询到数据！',
                  type: 'warning',
                  duration: MESSAGE_DURATION
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        },
        async handleEdit(){
          if(this.deptOptions.length == 0){
            await this.deptListLoad()
          }
          this.dialogVisual.editUserInfoDialogVisible = true
          this.userInfoForm.fullName = this.userInfo.fullName
          this.userInfoForm.updateImage = false
          this.userInfoForm.usrName = this.userInfo.usrName
          this.userInfoForm.gender = this.userInfo.gender
          this.userInfoForm.email = this.userInfo.email
          this.userInfoForm.mobilePhone = this.userInfo.mobilePhone
          this.userInfoForm.deptId = this.userInfo.deptId
          this.userInfoForm.imageUrl = this.userInfo.imageUrl
          if(this.userInfo.imageUrl!= null && this.userInfo.imageUrl != ''  ){
            this.userInfoForm.fileList.push({name:this.userInfo.usrName, url:this.userInfo.imageUrl})
          }
          this.userInfoForm.id = this.userInfo.id
        },
        goHome(){
          this.$router.push({path:'/mini_index'})
        },
        getUserInfo(){
          let url = "/bc/exa/usr/getUsrInfo"
          let dat0 = {
          }
          axios.post(url, dat0).then((response) => {
            if (response.data.code === 0) {
              let dat = response.data.data
              if(dat!= null && dat != ''){
                this.userInfo.fullName = dat.fullName
                this.userInfo.usrName = dat.usrName  
                this.userInfo.gender = dat.gentle
                if (dat.gentle == '0') {
                  this.userInfo.genderShow = '女'
                } else if (dat.gentle == '1') {
                  this.userInfo.genderShow = '男'
                }
                this.userInfo.id = dat.id
                this.userInfo.mobilePhone = dat.mobilePhone
                this.userInfo.email = dat.email
                this.userInfo.deptId = dat.deptId
                this.userInfo.deptName = dat.deptName
                this.userInfo.imageUrl = dat.headImag
                this.userInfo.init = true
              } else {
                this.$message({
                  showClose: true,
                  message: '未查询到规章制度信息！',
                  type: 'info',
                  duration: MESSAGE_DURATION
                })
              }
            }else{
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
            }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
        },
      },
      created(){
        //setTimeout(()=>{getToken(this.tokenObj)},200)
        setTimeout(()=>{this.getUserInfo(),200})
      },
      components:{
        mini_head_top
      }
    }
  </script>
  
  <style lang="less" scoped>
 
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/mini_self.vue